import moment from "moment";
import axios from "@/helpers/axios";
import types from "./types";
import router from "@/router";

export default {
  updateCustomDateRange: ({ commit }, date) => {
    commit(types.UPDATE_DATE_RANGE, date);
  },
  [types.FETCH_PRODUCTS]: ({ commit, state }, link) => {
    if (!link) {
      link = state.link;
    }
    return axios.get(link).then(response => {
      const { data, meta } = response.data;
      commit(types.FETCH_PRODUCTS, { data, meta, link });
    });
  },
  [types.FETCH_COLLECTION_PER_PAGE]: ({ commit, state }, link) => {
    if (!link) {
      link = state.link;
    }
    return axios.get(link).then(response => {
      const { data, meta } = response.data;
      commit(types.FETCH_COLLECTION_PER_PAGE, { data, meta, link });
    });
  },
  [types.USER_ADD]: ({ commit }, payload) => {
    return axios.post("/users", payload).then(response => {
      const { data } = response.data;
      commit(types.USER_ADD, data);
    });
  },
  [types.USERS_ADD]: ({ commit }, payload) => {
    commit(
      types.USERS_ADD,
      payload.map(user => {
        user.new = true;
        return user;
      })
    );
  },
  [types.USER_DELETE]: ({ commit }, payload) => {
    return axios.delete(`/users/${payload}`).then(() => {
      commit(types.USER_DELETE, payload);
    });
  },
  [types.USER_EDIT]: ({ commit }, payload) => {
    return axios.patch(`/users/${payload.id}`, payload.form).then(response => {
      var { data } = response.data;
      commit(types.USER_EDIT, data);
    });
  },
  [types.USER_LIST_PAGINATE]: async ({ commit, dispatch, state }, action) => {
    const { page, hasNextPage, size } = state.userMeta;
    const { user } = router.currentRoute.params;

    if (page == 1) {
      dispatch(types.SET_ACTIVE_USER, null);
    }

    if (hasNextPage) {
      return await axios
        .get(`/users?page[number]=${page}&page[size]=${size}&${action}`)
        .then(response => {
          const { data, meta } = response.data;
          if (page === 1 && data) {
            const activeUser = user || data[0];
            dispatch(types.SET_ACTIVE_USER, activeUser);
          }
          if (data && meta) {
            commit(types.USER_LIST_PAGINATE, {
              data: user ? [user, ...data] : data,
              meta
            });
          }
        });
    }
  },
  [types.USER_LIST_RESET]: ({ commit }) => {
    commit(types.USER_LIST_RESET);
  },
  [types.USER_REMOVE_NEW_TAG]: ({ commit }, payload) => {
    commit(types.USER_REMOVE_NEW_TAG, payload);
  },

  [types.GROUP_ADD]: ({ commit }, payload) => {
    return axios.post("/groups", payload).then(response => {
      const { data } = response.data;
      const meta = [
        {
          userId: payload.owner.value,
          key: `owner:group-${data.id}`,
          value: "Owner",
          label: "Creator"
        }
      ];
      return axios.post(`/users/${payload.owner.value}/meta`, meta).then(() => {
        let Users = [];
        return axios.get(`/users/${payload.owner.value}`).then(res => {
          const user = res.data.data;
          Users.push(user);
          data.Users = Users;
          commit(types.GROUP_ADD, data);
        });
      });
    });
  },
  [types.GROUP_ADD_MEMBER]: ({ commit }, payload) => {
    return axios.post("/groups/users", payload).then(async () => {
      let Users = [];
      for (var user of payload.users) {
        await axios.get(`/users/${user}`).then(res => {
          const user = res.data.data;
          Users.push(user);
        });
      }
      payload.users = Users;
      commit(types.GROUP_ADD_MEMBER, payload);
    });
  },
  [types.GROUP_DELETE]: ({ commit }, payload) => {
    return axios.delete(`/groups/${payload}`).then(() => {
      commit(types.GROUP_DELETE, payload);
    });
  },
  [types.GROUP_DELETE_MEMBER]: ({ commit }, payload) => {
    return axios
      .delete(`/groups/${payload.groupId}/users/${payload.userId}`)
      .then(() => {
        commit(types.GROUP_DELETE_MEMBER, payload);
      });
  },
  [types.GROUP_EDIT]: ({ commit }, payload) => {
    return axios.patch(`/groups/${payload.id}`, payload).then(() => {
      commit(types.GROUP_EDIT, payload);
    });
  },
  [types.GROUP_LIST_PAGINATE]: async ({ commit, state }, action) => {
    const { page, hasNextPage } = state.userMeta;
    if (hasNextPage) {
      return await axios
        .get(`/groups?page[number]=${page}&page[size]=10&${action}`)
        .then(response => {
          const { data, meta } = response.data;
          if (data && meta) {
            commit(types.GROUP_LIST_PAGINATE, { data, meta });
          }
        });
    }
  },
  [types.GROUP_LIST_RESET]: ({ commit }) => {
    commit(types.GROUP_LIST_RESET);
  },
  [types.USER_SET_TAB]: ({ commit }, payload) => {
    commit(types.USER_SET_TAB, payload);
  },
  [types.SET_ACTIVE_USER]: ({ commit }, user) => {
    commit(types.SET_ACTIVE_USER, user);
  },
  [types.HISTORY_ACTIVE_USER]: ({ commit }, user) => {
    commit(types.HISTORY_ACTIVE_USER, user);
  },
  [types.SET_SETTINGS_LOADER]: ({ commit }, payload) => {
    commit(types.SET_SETTINGS_LOADER, payload);
  },
  [types.FETCH_LOCATION_PAGINATE]: async ({ commit, state }, action) => {
    const { page, hasNextPage } = state.locationMeta;
    if (hasNextPage) {
      return await axios
        .get(`/locations?page[number]=${page}&page[size]=10&${action}`)
        .then(response => {
          const { data, meta } = response.data;
          if (data && meta) {
            commit(types.FETCH_LOCATION_PAGINATE, { data, meta });
          }
        });
    }
  },
  [types.LOCATION_LIST_RESET]: ({ commit }) => {
    commit(types.LOCATION_LIST_RESET);
  },
  [types.FETCH_CATEGORY_PAGINATE]: async ({ commit, state }, action) => {
    const { page, hasNextPage } = state.categoryMeta;
    if (hasNextPage) {
      return await axios
        .get(
          `/categories?page[number]=${page}&page[size]=10&fields=id,name,-Products&${action}`
        )
        .then(response => {
          const { data, meta } = response.data;
          if (data && meta) {
            commit(types.FETCH_CATEGORY_PAGINATE, { data, meta });
          }
        });
    }
  },
  [types.CATEGORY_LIST_RESET]: ({ commit }) => {
    commit(types.CATEGORY_LIST_RESET);
  },
  [types.EVENT_LIST_PAGINATE]: async ({ commit, state }, action) => {
    const { page, hasNextPage, size } = state.eventMeta;
    if (hasNextPage) {
      return await axios
        .get(`/events?page[number]=${page}&page[size]=${size}&${action}`)
        .then(response => {
          const { data, meta } = response.data;
          if (data && meta) {
            commit(types.EVENT_LIST_PAGINATE, { data, meta });
          }
        });
    }
  },
  [types.EVENT_LIST_RESET]: ({ commit }) => {
    commit(types.EVENT_LIST_RESET);
  },
  [types.FETCH_SCHEDULE_PAGINATE]: async ({ commit, state }, action) => {
    const { page, hasNextPage } = state.scheduleMeta;
    if (hasNextPage) {
      return await axios
        .get(`/schedules?page[number]=${page}&page[size]=10&${action}`)
        .then(response => {
          const { data, meta } = response.data;
          if (data && meta) {
            commit(types.FETCH_SCHEDULE_PAGINATE, { data, meta });
          }
        });
    }
  },
  [types.SET_SCHEDULE_NEW]: async ({ commit }, payload) => {
    return commit(types.SET_SCHEDULE_NEW, payload);
  },
  [types.SCHEDULE_LIST_RESET]: ({ commit }) => {
    commit(types.SCHEDULE_LIST_RESET);
  },
  [types.SET_PAYMENT_METHOD]: ({ commit }, payload) => {
    commit(types.SET_PAYMENT_METHOD, payload);
  },
  [types.GET_TOTAL_BOOKINGS_TODAY]: async ({ commit }, date = new Date()) => {
    const _date = moment(date).startOf("day");
    const params = new URLSearchParams();
    params.set("page[number]", 1);
    params.set("page[size]", 99999);
    params.set("search[startAt]", _date.toISOString());
    params.set("search[endAt]", _date.endOf("day").toISOString());
    params.set("search[status]", "!cancelled");
    params.set("count_only", true);

    try {
      const res = await axios.get(`/orders/packages?${params}`);
      commit(types.SET_TOTAL_BOOKINGS_TODAY, res.data.data || 0);
    } catch (error) {
      console.error(error);
    }
  }
};
